import { useMutation } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

type SendTestEmailPayload = {
  MarketingCampaignId: number;
  MarketingEmailId?: number;
  RecipientEmail: string;
};

export function useSendTestEmailMutation() {
  return useMutation({
    mutationFn: async (payload: SendTestEmailPayload) => {
      const res = postData({
        endpoint: 'api/email-marketing/test-send-email',
        payload,
      });
      return res;
    },
  });
}
